import {
    HTTP_INTERCEPTORS,
    HttpClientJsonpModule,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { ErrorHandler, importProvidersFrom, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// ROUTING

import { AppRoutingModule } from './app-routing.module';

// NGX PERMISSIONS
import { NgxMaskModule } from 'ngx-mask';
import { NgxPermissionsModule } from 'ngx-permissions';

// HASH LOCATION RELOAD

import { CurrencyPipe, LocationStrategy, PathLocationStrategy } from '@angular/common';

// COMPONENTS

import { AppComponent } from './app.component';

// INTERCEPTORS

import { HttpHeadersInterceptor } from './interceptors/http-headers.interceptor';
import { HttpUnauthorizedInterceptor } from './interceptors/http-unauthorized.interceptor';

// DIRECTIVES

import { CatchEventsModule } from './directives/catch-events.module';

//MODULE

import {
    KeycloakService,
    LoggerErrorModule,
    provideKeycloakAngular,
    SPRINTPAY_SERVICES_TOKEN,
    SprintPayAPIsModule,
    StatModule,
} from '@cargos/sprintpay-services';
import { PasswordModule } from './pages/auth/password/password.module';
import { TokenService } from './services/utils/token.service';

// Google Maps
import { GoogleMapsModule } from '@angular/google-maps';

// Google Analytics

import { environment } from 'src/environments/environment';
import { createGoogleAnalyticsConfig, GoogleAnalyticsModule } from './modules/google-analytics';
import { Config } from './utils/config';

// SERVICES

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplyForCargoFacilityModule } from './pages/auth/signup/apply-for-cargo-facility/apply-for-cargo-facility.module';
import { UrlService } from './services/url.service';
import { ApplicationErrorHandlerService } from './services/utils/application-error-handler.service';

let loggerErrorModuleProviders = LoggerErrorModule.forRoot({
    appSentryDsn: environment.appSentryDsn,
    appVersion: environment.appVersion,
    enableSentry: environment.enableSentry,
    environment: environment.environment,
}).providers;

loggerErrorModuleProviders = loggerErrorModuleProviders || [];

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        CatchEventsModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        NgxPermissionsModule.forRoot(),
        PasswordModule,
        ApplyForCargoFacilityModule,
        HttpClientJsonpModule,
        NgxMaskModule.forRoot(),
        SprintPayAPIsModule.forRoot({
            environment: environment.environment,
            tokenGetter: {
                tokenProvider: {
                    provide: SPRINTPAY_SERVICES_TOKEN,
                    useFactory: tokenFactory,
                    deps: [TokenService],
                },
            },
            config: {
                apisWithoutHeaders: Config.apisWithoutHeader,
                apisWithoutContentType: Config.apisWithoutContentType,
                apisWithoutAccessControl: Config.apisWithoutAccessControl,
                allowedDomains: Config.allowedDomains,
                googleMapApiKey: environment.googleMapApiKey,
            },
        }),
        GoogleAnalyticsModule.forRoot(createGoogleAnalyticsConfig(environment)),
        GoogleMapsModule,
        StatModule.forRoot({
            sdkKey: environment.sdkKey,
            user: {},
            options: {
                environment: {
                    tier: environment.environment,
                },
            },
        }),
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpHeadersInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpUnauthorizedInterceptor, multi: true },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: ErrorHandler, useClass: ApplicationErrorHandlerService },
        ...loggerErrorModuleProviders,
        UrlService,
        CurrencyPipe,
        provideKeycloakAngular(environment.keycloakConfig),
        provideHttpClient(withInterceptorsFromDi()),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideClientHydration(),
        importProvidersFrom(FormsModule, ReactiveFormsModule),
        KeycloakService,
    ],
})
export class AppModule {}

function tokenFactory(tokenService: TokenService): () => string | null {
    return () => tokenService.getCurrentUser();
}
